<template>
  <div style="width: 100%; height: 100%; position:fixed; top: 0; left: 0; z-index: 7; background: rgba(0,0,0,0.4);">
    <div style="position:absolute; width: 80%; height: 80%; background: white; border-radius: 10px; top: 50%; left: 50%; transform: translate(-50%, -50%);" @click.stop="dummy">
      <div style="width: 100%; height: 70px; line-height: 70px; font-size: 20px;">
        {{product.title}} pickings
      </div>
      <div style="width: 100%; height: calc(100% - 140px); overflow-y: auto;">
        <table class="table text-left">
          <tr>
            <th>Quantity</th>
            <th>Description</th>
          </tr>
          <tr v-for="item in items" :key="'midstock-item-' + item.id">
            <td class="text-center">{{item.quantity}}</td>
            <td>{{item.description}}</td>
          </tr>
        </table>
      </div>
      <div style="width: 100%; height: 70px; line-height: 70px; text-align: right; padding-right: 50px;">
        <button class="btn btn-dark" @click="closeView">Close</button>
      </div>
    </div>
  </div>
</template>

<script>

import { getProductPendingMidstock } from "../../api/product";
import { showDialog } from "../../api/utils";

export default {
  name: 'ProductMidestockView',
  props: {
    product: {
      type:Object,
      default: function(){return null;}
    },
    onClose: {
      type: Function,
      default: null,
    }
  },
  data() {
    return {
      items:[],
    }
  },
  created() {
  },
  mounted() {
    this.loadItems();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods:{
    dummy: function() {

    },
    closeView: function() {
      if(this.onClose !== null) {
        this.onClose();
      }
    },
    loadItems: function() {
      let self = this;
      getProductPendingMidstock(this.product.id)
        .then(function(data) {
          if(data.success === true) {
            self.$data.items = data.item;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ItemView/ProductMidStockView.vue